import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "track-company" }
const _hoisted_2 = {
  key: 1,
  class: "list"
}
const _hoisted_3 = {
  key: 0,
  class: "suggestions"
}
const _hoisted_4 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PulseSearch = _resolveComponent("PulseSearch")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Empty = _resolveComponent("Empty")
  const _component_CompanySuggestion = _resolveComponent("CompanySuggestion")
  const _component_Button = _resolveComponent("Button")
  const _component_Loader = _resolveComponent("Loader")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Divider = _resolveComponent("Divider")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title" }, " Track company ", -1 /* HOISTED */)),
    _createVNode(_component_PulseSearch, {
      ref: "search",
      modelValue: $data.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.name) = $event)),
      "vread-from": "valid",
      "onUpdate:valid": $event => (($data.valid) = $event),
      class: "search",
      regexp: "^.{2,}$",
      loading: $data.loading,
      disabled: $data.saving,
      placeholder: "Search for a company..."
    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid", "loading", "disabled"]),
    _createVNode(_component_ScrollBar, {
      class: "scrollbar",
      fade: "",
      disabled: $data.saving
    }, {
      default: _withCtx(() => [
        ($options.empty)
          ? (_openBlock(), _createBlock(_component_Empty, {
              key: 0,
              bordered: false,
              class: "empty",
              "bg-size": "36rem",
              "circle-size": "7.6rem"
            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
              ($options.tr_name)
                ? {
                    name: "sub-text",
                    fn: _withCtx(() => [
                      _cache[3] || (_cache[3] = _createTextVNode(" There are no companies matching your search query")),
                      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                      _createElementVNode("a", {
                        class: "pointer",
                        onClick: _cache[1] || (_cache[1] = $event => ($data.name = ''))
                      }, "Clear search")
                    ]),
                    key: "0"
                  }
                : {
                    name: "sub-text",
                    fn: _withCtx(() => [
                      _cache[5] || (_cache[5] = _createTextVNode(" Type a company name in the search field ")),
                      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                      _cache[7] || (_cache[7] = _createTextVNode(" to see the list of companies. "))
                    ]),
                    key: "1"
                  },
              ($options.tr_name)
                ? {
                    name: "image",
                    fn: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        width: "4rem",
                        height: "4rem",
                        icon: "search",
                        class: "icon-svg",
                        stroke: "var(--brand-500)"
                      })
                    ]),
                    key: "2"
                  }
                : {
                    name: "image",
                    fn: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        width: "4rem",
                        height: "4rem",
                        icon: "activity",
                        class: "icon-svg",
                        stroke: "var(--brand-500)"
                      })
                    ]),
                    key: "3"
                  }
            ]), 1024 /* DYNAMIC_SLOTS */))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              ($data.suggestions.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.suggestions, (suggestion) => {
                      return (_openBlock(), _createBlock(_component_CompanySuggestion, {
                        key: suggestion.linkedin_id,
                        disabled: $data.loading,
                        suggestion: suggestion,
                        onClick: $event => ($options.onSelect(suggestion.linkedin_id))
                      }, null, 8 /* PROPS */, ["disabled", "suggestion", "onClick"]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (!$data.show_more && !$data.loading)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          class: "button",
                          link: "",
                          onClick: $options.onShowMore
                        }, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode(" Show more ")
                          ])),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ])),
        ($data.loading)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 2 }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["disabled"]),
    _createVNode(_component_Divider, { m: "0 -2.4rem 2.4rem" }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        primary: "",
        class: "button",
        disabled: $data.saving,
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.$dispatch('track-company')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Icon, {
            stroke: "#EDEBE6",
            icon: "plus"
          }),
          _cache[9] || (_cache[9] = _createTextVNode(" Track Manually "))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ])
  ]))
}